export const translations = {
  en: {
    nav: {
      menu: "Menu",
      book: "Book a Table",
      about: "About",
      contact: "Contact",
    },
    hero: {
      title: "Portuguese Cuisine in Helsinki",
      subtitle: "Experience the taste of Portuguese delight",
      bookTable: "Book a Table",
      viewMenu: "View Menu",
    },
    booking: {
      title: "Book Your Table",
      name: "Full Name",
      email: "Email",
      phone: "Phone Number",
      date: "Date",
      time: "Time",
      guests: "Number of Guests",
      specialRequests: "Special Requests (optional)",
      submit: "Confirm Booking",
      submitting: "Submitting...",
      success:
        "Your booking has been confirmed! We look forward to serving you.",
      error: "Failed to submit booking. Please try again later.",
      errors: {
        nameRequired: "Please enter your name",
        emailRequired: "Please enter your email",
        invalidEmail: "Please enter a valid email address",
        dateRequired: "Please select a date",
        timeRequired: "Please select a time",
      },
      newsletter: "Subscribe to newsletter",
      newsletterInfo: "Receive special offers and updates from Wave of Flavors",
      makeAnother: "Make Another Booking",
      successMessage:
        "Thank you for your booking! We have saved your reservation and look forward to welcoming you to Wave of Flavors.",
    },
    menu: {
      title: "Our Menu",
      tapas: "Tapas",
      starters: "Starters",
      salads: "Salads",
      mains: "Main Courses",
      desserts: "Desserts",
      drinks: "Drinks",
    },
    footer: {
      aboutUsTitle: "About Us",
      aboutUsContent:
        "Wave of Flavors brings twisted Portuguese cuisine to Helsinki! Enjoy dishes in a cozy taverna setting.",
      openingHoursTitle: "Opening Hours",
      contactInfoTitle: "Contact Info",
      address: "Sturenkatu 28, Helsinki",
      phone: "+358 40 1803695",
      email: "waveofflavors@gmail.com",
      rights: "All Rights Reserved | 2025, Wave of Flavors | Made by",
      getDirections: "Get Directions",
    },
    banner: {
      todayFullyBooked:
        "NOTICE: Today's bookings are NOT AVAILABLE after 4:00 PM due to being fully booked. Please book for another day or time.",
    },
  },
  fi: {
    nav: {
      menu: "Ruokalista",
      book: "Varaa Pöytä",
      about: "Meistä",
      contact: "Yhteystiedot",
    },
    hero: {
      title: "Aito portugalilainen keittiö Helsingissä",
      subtitle: "Koe pohjoismaisen keittiön erinomaisuus",
      bookTable: "Varaa Pöytä",
      viewMenu: "Katso Menu",
    },
    booking: {
      title: "Varaa Pöytä",
      name: "Nimi",
      email: "Sähköposti",
      phone: "Puhelin",
      date: "Päivämäärä",
      time: "Aika",
      guests: "Henkilömäärä",
      specialRequests: "Erityistoiveet (valinnainen)",
      submit: "Vahvista Varaus",
      submitting: "Lähetetään...",
      success: "Varauksesi on vahvistettu! Odotamme innolla palvelemaan sinua.",
      error: "Varauksen lähetys epäonnistui. Yritä uudelleen myöhemmin.",
      errors: {
        nameRequired: "Syötä nimesi",
        emailRequired: "Syötä sähköpostiosoitteesi",
        invalidEmail: "Syötä kelvollinen sähköpostiosoite",
        dateRequired: "Valitse päivämäärä",
        timeRequired: "Valitse aika",
      },
      newsletter: "Tilaa uutiskirje",
      newsletterInfo:
        "Vastaanota erikoistarjouksia ja päivityksiä Wave of Flavorsilta",
      makeAnother: "Tee toinen varaus",
      successMessage:
        "Kiitos varauksestasi! Olemme tallentaneet varauksesi ja odotamme innolla tervetulleeksi sinut Wave of Flavorsiin.",
    },
    menu: {
      title: "Ruokalista",
      tapas: "Tapas",
      starters: "Alkuruoat",
      salads: "Salaatit",
      mains: "Pääruoat",
      desserts: "Jälkiruoat",
      drinks: "Juomat",
    },
    footer: {
      aboutUsTitle: "Meistä",
      aboutUsContent:
        "Wave of Flavors tuo käänteisen portugalilaisen keittiön Helsinkiin! Nauti ruoista kodikkaassa tavernaympäristössä.",
      openingHoursTitle: "Aukioloajat",
      contactInfoTitle: "Yhteystiedot",
      address: "Sturenkatu 28, Helsinki",
      phone: "+358 40 1803695",
      email: "waveofflavors@gmail.com",
      rights: "Kaikki oikeudet pidätetään | 2025, Wave of Flavors | Tehnyt",
      getDirections: "Ajo-ohjeet",
    },
    banner: {
      todayFullyBooked:
        "HUOMIO: Tämän päivän varauksia EI OLE SAATAVILLA klo 16:00 jälkeen täysvarauksien vuoksi. Ole hyvä ja varaa toiselle päivälle tai ajankohdalle.",
      may12Restriction: "HUOMIO: 12.5.2025 ravintola on avoinna vain klo 16:00 jälkeen.",
    },
  },
};
